import { formatDateTime, formatCurrency, extractRecordId } from './helpers';

/**
 * Transforms a single usage charge item for table display
 * @param {Object} element - Usage charge element from API
 * @param {number} index - Index for serial number
 * @returns {Object} Transformed usage charge object
 */
export const transformUsageChargeItem = (element, index) => ({
    id: index + 1,
    record_id: extractRecordId(element.record_id),
    amount: formatCurrency(element.amount),
    store: element.store || 'N/A',
    type: element.type || 'N/A',
    created_at: formatDateTime(element.created_at),
});

/**
 * Transforms array of usage charges into DataTable format
 * @param {Array} usageCharges - Array of usage charge objects from API
 * @param {Array} columns - Table column configuration
 * @returns {Object} DataTable formatted object with columns and rows
 */
export const transformUsageChargesToTableData = (usageCharges, columns) => {
    const rows = usageCharges.map((element, index) => transformUsageChargeItem(element, index));

    return {
        columns,
        rows,
    };
};

